import React from 'react';
import {
  DatePicker as MaterialDatePicker,
  DatePickerProps as MaterialDatePickerProps,
  MuiPickersUtilsProvider,
} from '@material-ui/pickers';
import DateFnsUtils from '@date-io/moment';
import 'moment/locale/pl';

export interface DatePickerProps extends MaterialDatePickerProps {}

const DatePicker = (props: DatePickerProps) => {
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale="pl">
      <MaterialDatePicker {...props} />
    </MuiPickersUtilsProvider>
  );
};

export default DatePicker;
